import React from 'react';
import './ContactInput.css'
import '../../root.css'

const ContactInput = (props) => {
    return ( 
        <input className='CInput' type={props.InputType} placeholder={props.InputPlaceholder}/>
     );
}
 
export default ContactInput;